import { TwitterNextScript } from './TwitterNextScript';
import { TwitterStyle } from './TwitterStyle';

export const TwitterScript = ({ nonce }: { nonce: string }) => (
  <>
    <TwitterNextScript nonce={nonce} />
    <TwitterStyle />
  </>
);
